module.exports = __webpack_public_path__ + "img/35.6a740f54.jpg";